// extracted by mini-css-extract-plugin
module.exports = {"sectionWrapper":"content-with-image-section_sectionWrapper__o_Vp0","sectionImage":"content-with-image-section_sectionImage__fR_3a"};